import Icon from '../components/Icon.vue'

Icon.register({
  font: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M432 416c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-128c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h19.6l-23.3-64h-152.6l-23.3 64h19.6c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-128c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h23.4l130.7-362.3c4.1-12 17.6-21.7 30.3-21.7h0 47.2 0c12.6 0 26.2 9.7 30.3 21.7l130.7 362.3h23.4zM176.8 272h94.3l-47.2-129.5z'
      }
    ]
  }
})
